const customVariableRegex = /\[.*]/;

const hasCustomVariableToken = value => customVariableRegex.test(value);

export default hasCustomVariableToken;
